// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Title_wrapper__2fwKe","title":"Title_title__eT0Gb","titleText":"Title_titleText__2ONSf","titleAction":"Title_titleAction__2bHsC","hint":"Title_hint__1PwcT"};